import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MessageFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.738 0H9.68A8.985 8.985 0 0 0 .66 9.025v15.642a8.985 8.985 0 0 0 9.02 9.025h3.007c1.604 0 3.007 1.304 3.007 3.008v5.215c0 1.804 2.104 2.707 3.407 1.604l10.223-8.924c.2-.201.401-.301.702-.401.4-.201.802-.301 1.202-.301h2.506c5.212 0 9.621-3.71 10.724-8.624v-.2c.2-.702.2-1.505.2-2.307V9.025C44.758 4.01 40.75 0 35.738 0Z"
  }));
});
MessageFill.displayName = 'MessageFill';
MessageFill.defaultProps = {
  'aria-label': 'MessageFill'
};
export default MessageFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MessageFill.js
// module id = 3836
// module chunks = 11